module.exports = __webpack_public_path__ + "static/media/lock-upgrade.364134f4.png";